import * as Types from "../../actions/constants";

const initialState = {
  
  documentData:{
    loading: false,
    error: false,
    success: false,
    rows: { data: [], meta: [] }, 
  },
  indexData:{
    loading: false,
    error: false,
    success: false,
    rows: { data: [], meta: [] }, 
  },
  createData:{
    loading: false,
    error: false,
    success: false,
    rows: { data: [], meta: [] }, 
  },
  updateData:{
    loading: false,
    error: false,
    success: false,
    rows: { data: [], meta: [] }, 
  }
  
};

export default (state = initialState, action) => {

  switch (action.type) {
     case Types.GET_DOCUMENT:
        return {
          ...state,
          documentData: {
            loading: true,
            error: false,
            success: false,
            rows: { data: [], meta: [] },
          },
        };
      case Types.DOCUMENT_SUCCESS:
        return {
          ...state,
          documentData: {
            loading: false,
            error: false,
            success: true,
            rows: action.response.data,
          },
        };
      case Types.DOCUMENT_ERROR:
        return {
          ...state,
          documentData: {
            loading: false,
            error: true,
            success: false,
            rows: action.response,
          },
        };
        case Types.GET_DOCUMENT_BY_ID:
          return {
            ...state,
            indexData: {
              loading: true,
              error: false,
              success: false,
              rows: { data: [], meta: [] },
            },
          };
        case Types.DOCUMENT_BY_ID_SUCCESS:
          return {
            ...state,
            indexData: {
              loading: false,
              error: false,
              success: true,
              rows: action.response.data,
            },
          };
        case Types.DOCUMENT_BY_ID_ERROR:
          return {
            ...state,
            indexData: {
              loading: false,
              error: true,
              success: false,
              rows: action.response,
            },
          };  


        case Types.CREATE_DOCUMENT:
          return {
            ...state,
            createData: {
              loading: true,
              error: false,
              success: false,
              rows: { data: [], meta: [] },
            },
          };
        case Types.CREATE_DOCUMENT_SUCCESS:
          return {
            ...state,
            createData: {
              loading: false,
              error: false,
              success: true,
              rows: action.response.data,
            },
          };
        case Types.CREATE_DOCUMENT_ERROR:
          return {
            ...state,
            createData: {
              loading: false,
              error: true,
              success: false,
              rows: action.error.error,
            },
          };  
          case Types.RESET_CREATE_DOCUMENT:
            return {
              ...state,
              createData: {
                loading: false,
                error: false,
                success: false,
                rows: { data: [], meta: [] },
              },
            };      








            case Types.UPDATE_DOCUMENT:
              return {
                ...state,
                updateData: {
                  loading: true,
                  error: false,
                  success: false,
                  rows: { data: [], meta: [] },
                },
              };
            case Types.UPDATE_DOCUMENT_SUCCESS:
              return {
                ...state,
                updateData: {
                  loading: false,
                  error: false,
                  success: true,
                  rows: action.response.data,
                },
              };
            case Types.UPDATE_DOCUMENT_ERROR:
              return {
                ...state,
                updateData: {
                  loading: false,
                  error: true,
                  success: false,
                  rows: action.error.error,
                },
              };  
              case Types.RESET_UPDATE_DOCUMENT:
                return {
                  ...state,
                  updateData: {
                    loading: false,
                    error: false,
                    success: false,
                    rows: { data: [], meta: [] },
                  },
                };      
    






    default:
      return state;
  }
};
